<template>
  <DataListStateful
    title="Страны"
    resource="countries"
    store="countries"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "Префикс",
          name: "prefix",
          dataPath: "Prefix",
          sortable: true,
        },
        {
          title: "Код Страны(alpha-3)",
          name: "isoCode",
          dataPath: "IsoCode",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        prefix: {
          title: "Префикс",
          type: "text",
        },
        isoCode: {
          title: "Код Страны",
          type: "text",
        },
      },
    };
  },
};
</script>
